import TenantLabel from './TenantLabel.vue';

export default TenantLabel;
